export const state = {
  notificacoes: [],
};

export default {};
